import { MealTime } from "@/clients/models/MealTime";
import { LifestyleService } from "@/clients/services/LifestyleService";
import { QueryKeys } from "@/constants/query-keys";
import { useQuery } from "@tanstack/react-query";

export const useGetLifestyleOptions = (mealTime: MealTime) => {
  const { data, isLoading, isError, error } = useQuery({
    queryKey: [QueryKeys.LIFESTYLE_OPTIONS, mealTime],
    queryFn: async () => {
      const { data } =
        await LifestyleService.getLifestylePreferenceOptionsApiV1LifestyleMealTimeOptionsGet(
          mealTime,
        );

      return data;
    },
  });

  return {
    options: data,
    isLoading,
    isError,
    error,
  };
};
